import { render, staticRenderFns } from "./IconTraining.vue?vue&type=template&id=bcf8d670&scoped=true"
import script from "./IconTraining.vue?vue&type=script&lang=js"
export * from "./IconTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf8d670",
  null
  
)

export default component.exports